import { render } from "./phones.vue?vue&type=template&id=18bb3319&scoped=true&lang=pug"
import script from "./phones.vue?vue&type=script&lang=js"
export * from "./phones.vue?vue&type=script&lang=js"

import "./phones.vue?vue&type=style&index=0&id=18bb3319&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bb3319"]])

export default __exports__